const MAX_VALUE_DIGITS = 6;
const MAX_FRACTION_DIGITS = 4;

function getIntegerDigitCount(value: number): number {
  const absolute = Math.abs(value);

  if (!Number.isFinite(absolute) || absolute < 1) {
    return 1;
  }

  return Math.floor(Math.log10(absolute)) + 1;
}

function formatLimitedDigits(value: number, options?: { roundTo4?: boolean; stripTrailingZeros?: boolean }): string {
  if (!Number.isFinite(value)) {
    return '';
  }

  const prepared = options?.roundTo4 ? Math.round(value * 1e4) / 1e4 : value;
  const integerDigits = getIntegerDigitCount(prepared);
  const fractionDigits = Math.min(MAX_FRACTION_DIGITS, Math.max(0, MAX_VALUE_DIGITS - integerDigits));

  if (fractionDigits === 0 || Math.abs(prepared - Math.trunc(prepared)) < 1e-10) {
    return String(Math.trunc(prepared));
  }

  const factor = 10 ** fractionDigits;
  const limited = options?.roundTo4
    ? Math.trunc(prepared * factor + Math.sign(prepared) * Number.EPSILON) / factor
    : Math.trunc(prepared * factor) / factor;
  const fixed = limited.toFixed(fractionDigits);

  return options?.stripTrailingZeros ? fixed.replace(/\.?0+$/, '') : fixed;
}

/** Axis / grid labels: truncate to ≤6 significant digits, strip trailing zeros. */
export function formatGridLabel(value: number): string {
  return formatLimitedDigits(value, { stripTrailingZeros: true });
}

/** Tooltip values: round to 4 decimals, then ≤6 total digits / ≤4 fractional. */
export function formatTooltipNumber(value: number): string {
  return formatLimitedDigits(value, { roundTo4: true });
}
